import React from 'react'

const MissingRoute = () => {

  return (
    <div className='missing'>
        <div className="banner-message">
            <div className="section-title">
                <h1>404</h1>
                <p>Oops. This page doesn't exists</p>
            </div>
        </div>
    </div>
  )
}

export default MissingRoute